export const setPagination = {
  SET_PAGINATION(state, payload) {
    state.profilesPagination = payload
  }
}
